// アップロードを許可するファイル拡張子
export const ACCEPTED_EXTENSIONS = ['.zip'] as const

/**
 * accept属性向けにカンマ区切り文字列を生成するヘルパー
 */
export const getAcceptString = (): string => ACCEPTED_EXTENSIONS.join(',')

/**
 * フォームに追加されたファイル拡張子が許可されたものか返す
 * @param fileName ファイル名
 * @returns 許可/未許可
 */
export const isAcceptedExtension = (fileName: string): boolean => {
  const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase()
  return ACCEPTED_EXTENSIONS.includes(ext as (typeof ACCEPTED_EXTENSIONS)[number])
}

// アップロードを許可する拡張子を含めたファイル名の長さ（.zipを想定）
export const ACCEPTED_FILE_NAME_WITH_EXTENSION_LENGTH = 154 as const
